import { render, staticRenderFns } from "./StandaloneEditDialog.vue?vue&type=template&id=466b3ce5&scoped=true&"
import script from "./StandaloneEditDialog.vue?vue&type=script&lang=ts&"
export * from "./StandaloneEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./StandaloneEditDialog.vue?vue&type=style&index=0&id=466b3ce5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b3ce5",
  null
  
)

export default component.exports